// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__349qD","tabsBox":"styles_tabsBox__3w8pG","createButton":"styles_createButton__24y5I"};